module.exports = __webpack_public_path__ + "static/img/qdcc.7ecef0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/qdcc.png
// module id = w6XW
// module chunks = 93